import styled from 'styled-components';
import mainColors from '../../main-colors';

const ErrorWrapper = styled.div`
  position: relative;
  max-width: 210px;

  .error-message {
    color: ${mainColors.error_color};
    position: absolute;
    left: 50%;
    transform: translateX(-50%);
    white-space: nowrap;
    margin-top: 2px;
  }
`;

export default ErrorWrapper;
